import { fraxtal } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createFraxtalChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createFraxtalChainCustom({
    client: createClient({
      chain: fraxtal,
      httpRpcs: fraxtalHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'Fraxscan',
      baseUrl: 'https://fraxscan.com',
      chainId: 252,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateFraxtalChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createFraxtalChainCustom = ({
  client,
  explorer,
}: CreateFraxtalChainCustomParameters): Chain => ({
  id: 252,
  network: 'fraxtal',
  name: 'Fraxtal',
  nativeToken: {
    name: 'Frax',
    symbol: 'FRAX',
    decimals: 18,
    currency: {
      symbol: 'FRAX',
      type: 'CryptoCurrency',
      id: 'frax-share',
      name: 'Frax',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0xfc00000000000000000000000000000000000002',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'fraxtal',
  defillamaId: undefined,
})

export const fraxtalHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.frax.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://fraxtal.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://fraxtal.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://fraxtal-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const fraxtalWebsocketRpcUrls: string[] = ['wss://fraxtal.drpc.org']
